var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.44 22.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-J3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.31,12.34a2.26,2.26,0,0,0,2-1.15l4-7.28a1.12,1.12,0,0,0-1-1.66H4.72L3.66,0H0V2.25H2.23l4,8.51L4.76,13.5a2.24,2.24,0,0,0,2,3.33H20.18V14.59H6.72L8,12.35h8.35ZM5.78,4.49H19.41l-3.1,5.6H8.44Zm.94,13.45A2.25,2.25,0,1,0,9,20.19a2.24,2.24,0,0,0-2.24-2.25Zm11.22,0a2.25,2.25,0,1,0,2.24,2.25A2.24,2.24,0,0,0,17.94,17.94Z",
    transform: "translate(0.01 -0.01)",
    fill: "#bac7d6",
    fillOpacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ3);
export default __webpack_public_path__ + "static/media/J3.1eaf1c35f9af2dabb8a2695cac2a4457.svg";
export { ForwardRef as ReactComponent };